import { __assign, __read, __spreadArray } from "tslib";
import { TravellerFieldEnum } from '@websky/graphql';
import { getUserValue } from '../utils';
export var getAvailableSegments = function (segments, passengers, servicesMap) {
    var availableSegments = [];
    var servicesSegmentIds = Object.keys(servicesMap);
    segments.forEach(function (segment) {
        if (servicesSegmentIds.includes(segment.id)) {
            var passengersArray_1 = [];
            var passengerIds_1 = Object.keys(servicesMap[segment.id]);
            var direction = [segment.departure.airport.city.name, segment.arrival.airport.city.name].join(' – ');
            passengers.forEach(function (passenger) {
                if (passengerIds_1.includes(passenger.id)) {
                    var firstName = getUserValue(passenger, TravellerFieldEnum.FirstName), lastName = getUserValue(passenger, TravellerFieldEnum.LastName);
                    var name = [firstName === null || firstName === void 0 ? void 0 : firstName.toLowerCase(), lastName === null || lastName === void 0 ? void 0 : lastName.toLowerCase()].filter(Boolean).join(' ');
                    passengersArray_1 = __spreadArray(__spreadArray([], __read(passengersArray_1), false), [
                        {
                            passengerId: passenger.id,
                            segmentId: segment.id,
                            serviceId: servicesMap[segment.id][passenger.id],
                            name: name
                        }
                    ], false);
                }
            });
            availableSegments = __spreadArray(__spreadArray([], __read(availableSegments), false), [
                {
                    segmentId: segment.id,
                    passengers: passengersArray_1,
                    direction: direction
                }
            ], false);
        }
    });
    return availableSegments;
};
export var computeServicesMap = function (services, selectedServices) {
    var servicesMap = {};
    services.forEach(function (service) {
        var segmentIds = new Set(service.allowedSegments.reduce(function (acc, ids) { return __spreadArray(__spreadArray([], __read(acc), false), __read(ids), false); }, []));
        var passengerIds = new Set(__spreadArray(__spreadArray([], __read(service.allowedPassengers.reduce(function (acc, ids) { return __spreadArray(__spreadArray([], __read(acc), false), __read(ids), false); }, [])), false), __read(Object.keys(selectedServices)), false));
        segmentIds.forEach(function (segmentId) {
            passengerIds.forEach(function (passengerId) {
                var _a, _b;
                var _c, _d;
                var serviceByPassenger = (_c = selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices[passengerId]) !== null && _c !== void 0 ? _c : {};
                var alreadySelectedService = (_d = Object.keys(serviceByPassenger)) === null || _d === void 0 ? void 0 : _d.find(function (serviceId) {
                    var _a;
                    return (((_a = selectedServices[passengerId][serviceId].find(function (selected) { return selected.segments[0] === segmentId; })) === null || _a === void 0 ? void 0 : _a.number) > 0 && services.map(function (service) { return service.id; }).includes(serviceId));
                });
                servicesMap = __assign(__assign({}, servicesMap), (_a = {}, _a[segmentId] = __assign(__assign({}, servicesMap[segmentId]), (_b = {}, _b[passengerId] = typeof alreadySelectedService !== 'undefined' ? alreadySelectedService : service.id, _b)), _a));
            });
        });
    });
    return servicesMap;
};
export var getNewSelectedServices = function (serviceMap, selectedServicesState, allSegments) {
    var selectedServices = [];
    var selectedSegments = Object.keys(selectedServicesState);
    var availableSegments = Object.keys(serviceMap);
    if (allSegments) {
        var firstSegment_1 = selectedSegments[0];
        var selectedPassengers = (selectedServicesState === null || selectedServicesState === void 0 ? void 0 : selectedServicesState[firstSegment_1])
            ? Object.keys(selectedServicesState[firstSegment_1])
            : [];
        selectedPassengers.forEach(function (passenger) {
            availableSegments.forEach(function (segmentId) {
                selectedServices.push({
                    count: selectedServicesState[firstSegment_1][passenger],
                    serviceId: serviceMap[firstSegment_1][passenger],
                    segmentIds: [segmentId],
                    passengerId: passenger
                });
            });
        });
    }
    else {
        availableSegments.forEach(function (segment) {
            var passengers = Object.keys(serviceMap[segment]);
            passengers.forEach(function (passenger) {
                var _a;
                if ((_a = selectedServicesState[segment]) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(passenger)) {
                    selectedServices.push({
                        serviceId: serviceMap[segment][passenger],
                        segmentIds: [segment],
                        count: selectedServicesState[segment][passenger],
                        passengerId: passenger
                    });
                }
            });
        });
    }
    return selectedServices;
};
